import React from 'react';
import PaperPractice from '../components/PaperPractice';

const PaperPracticePage: React.FC = () => {
  return (
    <div className="container mx-auto">
      <h1 className="text-2xl font-bold mb-6">Luyện tập viết</h1>
      <PaperPractice />
    </div>
  );
};

export default PaperPracticePage; 